exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-page-single-js": () => import("./../../../src/templates/PageSingle.js" /* webpackChunkName: "component---src-templates-page-single-js" */),
  "component---src-templates-portfolio-single-js": () => import("./../../../src/templates/PortfolioSingle.js" /* webpackChunkName: "component---src-templates-portfolio-single-js" */)
}

